import api from "../Api";
import { encryptId } from "../../utils/encrypt";


const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get My Order
export const getMyOrder = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/my/order", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: {
          order: []
        },
        message: "تم جلب البيانات بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get My Drinks
export const getMyDrinks = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/my/drinks", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: {
          order: []
        },
        message: "تم جلب البيانات بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Get Client Menus (No Token Required)
export const getClientMenus = async () => {
  try {
    const res = await api.get("/user/client/menus", {
      params: {
        api_password: "AI_Pos_passCode2026",
      },
      headers: {
        Accept: "application/json",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: {
          products: [...]
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Shared Drink By Encrypted ID
export const getSharedDrink = async (id) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const encryptedId = encryptId(id);

    const res = await api.get(
      `/user/shared/drink/${encodeURIComponent(encryptedId)}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// // ✅ Get Shared Drink By Provided Encrypted ID
// export const getSharedDrinkByEncryptedId = async (encryptedId) => {
//   const headers = {
//     ...getAuthHeaders(),
//     Accept: "application/json",
//   };

//   try {
//     const res = await api.get(`/user/shared/drink/${encryptedId}`, {
//       headers,
//       params: {
//         api_password: "AI_Pos_passCode2026",
//       },
//     });

//     return res.data;
//   } catch (error) {
//     const serverData = error?.response?.data;
//     if (serverData?.message) throw new Error(serverData.message);
//     throw error;
//   }
// };
// ✅ Get Shared Drink By Product Code
export const getSharedDrinkById = async (code) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(`/user/shared/drink/${encodeURIComponent(code)}`, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Rate Drink
export const rateDrink = async ({ drink_id, rate, comment }) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const formData = new FormData();
    formData.append("drink_id", drink_id);
    formData.append("rate", rate);
    formData.append("comment", comment || "");

    const res = await api.post("/rate/drink", formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
